import classNames from 'classnames'
import { useEffect } from 'react'

export function BreakoutDrawer({
  open,
  onClose,
  className,
  placement,
  children,
}: {
  open: boolean
  onClose: () => void
  className?: string
  placement: string
  children?: React.ReactNode
}) {
  useEffect(() => {
    if (!open) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [open, onClose])

  if (!open) return null

  return (
    // The backdrop click is a mouse shortcut; Escape closes it from the keyboard.
    <div
      role="presentation"
      onClick={onClose}
      className={classNames(
        'fixed inset-0 z-50 bg-dialog-background',
        className
      )}
    >
      <div
        className={classNames(
          'fixed z-50 h-full w-[300px] bg-core-tertiary shadow-lg',
          className,
          {
            'right-0': placement === 'right',
            'left-0': placement === 'left',
          }
        )}
      >
        {children}
      </div>
    </div>
  )
}

{
  /* <Drawer
open={open}
onClose={closeDrawer}
className=""
placement="right"
>
{mounted && <MobileNavigationDrawer closeDrawer={closeDrawer} />}
</Drawer> */
}
